import { authConstants } from '@constants/user';

const initialState = {
    user: null,
    loading: true,
};

export function auth(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGIN_SUCCESS:
        case authConstants.SET_USER:
            return { ...state, loading: false, user: action.user };
        case authConstants.SET_USER_LOADING:
            return { ...state, loading: action.payload };
        case authConstants.LOGIN_FAILURE:
        case authConstants.LOGOUT:
            return { loading: false, user: null };
        default:
            return state;
    }
}
